import axios from 'axios';
import { ConsentHtmlSignDocumentData } from 'src/ts/interfaces/documents/consent-html-sign-document-data';


interface CreateFinalSignDocsParams {
  // data: {
  //   tutorFullName: string;
  //   tutorId: string;
  //   tutorEmail: string;
  //   patientName: string;
  //   patientId: string;
  //   patientCountryId: string;
  //   carehomeName: string;
  // };
  documentCategory: string;
  data: Record<any, any>;
  signatures: Record<string, string>;
  docId: string;
  signRequestId: string;
  ipAddress: string;
  userAgent: string;
  geoLocation: object;
  metadata: object;
  locale: string;
  acceptedTerms: boolean;
  zohoDealName: string;
  zohoDealId: string;
}

export const createFinalSignDocsService = async ({ docId, signatures, signRequestId, ipAddress, userAgent, geoLocation, metadata, locale, acceptedTerms, data, documentCategory, zohoDealName, zohoDealId }: CreateFinalSignDocsParams) => {
  try {
    const response = await axios.post(`/signdoc/create-final-sign-docs`, { docId, signatures, signRequestId, ipAddress, userAgent, geoLocation, metadata, locale, acceptedTerms, data, documentCategory, zohoDealName, zohoDealId });

    const returnValue = response.data.data as ConsentHtmlSignDocumentData;
    return returnValue;
  } catch (error: any) {

    return 'verifyInvalid';
  }
};